import { DmBtnPrimary } from '../../dm/DmFormPrimitives';
import { ErrorBanner } from '../../dm/DmBanners';
import { apiErrorMessage } from '../../../../../utils/apiError';
import { ShipToForm } from './ShipToForm';
import type { UseOrthopulseOrderFlowResult } from './useOrthopulseOrderFlow';

interface ShipToStepCardProps {
    flow: UseOrthopulseOrderFlowResult;
}

// Step 1 of the flow: ship-to target/form plus the transition into step 2.
function ShipToStepCard({ flow }: ShipToStepCardProps) {
    const { shipToForms, errors, previewWithShipTo, isPreviewDisabled, handlePreview } = flow;

    return (
        <div className="bg-white rounded-xl border border-gray-200 p-6 flex flex-col gap-4">
            <ShipToForm
                target={shipToForms.target}
                onTargetChange={shipToForms.setTarget}
                values={shipToForms.values}
                onValuesChange={shipToForms.setValues}
                errors={errors}
                unmatchedState={shipToForms.unmatchedState}
            />

            {previewWithShipTo.isError && (
                <ErrorBanner
                    message={apiErrorMessage(
                        previewWithShipTo.error,
                        'Failed to load the order preview'
                    )}
                />
            )}

            <div className="flex justify-end">
                <DmBtnPrimary onClick={handlePreview} disabled={isPreviewDisabled}>
                    {previewWithShipTo.isPending ? 'Loading preview…' : 'Preview email'}
                </DmBtnPrimary>
            </div>
        </div>
    );
}

export { ShipToStepCard };
